import React from "react";
import { Card } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./index.scss";

type QuickAccessItemBase = {
  title: string;
  icon?: React.ReactNode;
};

export type QuickAccessItem = QuickAccessItemBase &
  (
    | { route: string; customAction?: never }
    | { route?: never; customAction: () => void }
  );

interface QuickAccessProps {
  items?: QuickAccessItem[];
  useGrid?: boolean;
}

const QuickAccess: React.FC<QuickAccessProps> = ({
  items = [],
  useGrid = false,
}) => {
  const navigate = useNavigate();

  const defaultItems: QuickAccessItem[] = [
    { title: "Review meeting notes", route: "/home/meetinghub" },
    { title: "Generate report", route: "/home/financial-plan-list" },
    { title: "Upload a document", route: "/home/filehub" },
  ];

  const quickAccessItems = items.length > 0 ? items : defaultItems;

  const handleItemClick = (item: QuickAccessItem) => {
    if (item.customAction) {
      item.customAction();
    } else if (item.route) {
      navigate(item.route);
    }
  };

  return (
    <Card
      title="Quick Access"
      variant="borderless"
      className={`quick-access-card ${useGrid ? "grid-layout" : ""}`}
    >
      <div className={`quick-access-items ${useGrid ? "grid-items" : ""}`}>
        {quickAccessItems.map((item, index) => (
          <button
            type="button"
            key={index}
            className="quick-access-item"
            onClick={() => handleItemClick(item)}
          >
            <div className="quick-access-content">
              {item.icon && (
                <span className="quick-access-icon">{item.icon}</span>
              )}
              {item.title}
            </div>
            <RightOutlined className="quick-access-arrow" />
          </button>
        ))}
      </div>
    </Card>
  );
};

export default QuickAccess;
